export default "__VITE_ASSET__5e8c7b01__"